import { render, staticRenderFns } from "./AwardTypeList.vue?vue&type=template&id=3948a17a&scoped=true"
import script from "./AwardTypeList.vue?vue&type=script&lang=js"
export * from "./AwardTypeList.vue?vue&type=script&lang=js"
import style0 from "./AwardTypeList.vue?vue&type=style&index=0&id=3948a17a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3948a17a",
  null
  
)

export default component.exports